import React from 'react';
import { MessageProps, Icon } from 'semantic-ui-react';

import { styled } from '@modules/common/components/ThemeProvider/utils';

import BaseBanner from './BaseMessage';
import { getBannerIconStyles } from './WarningMessage';

type Props = {
  header?: string;
} & MessageProps;

const ErrorMessage = (props: Props) => {
  return (
    <StyledErrorMessage style={props.style}>
      <div className="icon-wrapper">
        <Icon name="x" />
      </div>
      <BaseBanner {...props} style={{ width: '100%', marginTop: '0' }}>
        {props.children}
      </BaseBanner>
    </StyledErrorMessage>
  );
};

export default ErrorMessage;

const StyledErrorMessage = styled('div')`
  display: flex;
  width: 100%;

  ${getBannerIconStyles('#bf2c00')}
`;
